module.exports = __webpack_public_path__ + "img/公司愿景pic.22cdd53c.png";